import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6598093c")

_pushScopeId("data-v-6598093c")
const _hoisted_1 = { class: "tl" }
const _hoisted_2 = { class: "tl-time" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.slice(0,3), (item) => {
      return (_openBlock(), _createBlock("div", {
        class: "tl-item",
        key: item.id
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", null, _toDisplayString(_ctx.fmTime(item.happen_time)), 1)
        ]),
        _createVNode("a", {
          href: _ctx.link(item),
          class: "tl-content"
        }, _toDisplayString(item.news_title), 9, ["href"])
      ]))
    }), 128))
  ]))
})